module.exports = __webpack_public_path__ + "static/img/tianzhengwan.cf29e6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/medicines/tianzhengwan.jpg
// module id = L9oJ
// module chunks = 1